// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yzKA0","option":"styles_option__2C54E","active":"styles_active__wtEa6"};